import { createSlice, createAsyncThunk, isAnyOf } from '@reduxjs/toolkit';
import { IInitialState, RootState } from '../../../reduxService';
import * as BeMaccaferriStoreHelper from '../../api/store/BeMaccaferriStoreHelper';
import { MaterialType } from '../../enum/Material';
import { IMaterialResponse } from '../../api/IApiResponse';

const initialState: IInitialState<IMaterialResponse[]> = {
    initialState: true,
};

export const materialSlice = createSlice({
    name: 'material',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addMatcher(isAnyOf(fetchMaterialsByType.pending, fetchStillingBasingMaterials.pending), (state, action) => {
                state.data = undefined;
                state.pending = true;
                state.error = undefined;
                state.initialState = false;
            })
            .addMatcher(isAnyOf(fetchMaterialsByType.fulfilled, fetchStillingBasingMaterials.fulfilled), (state, action) => {
                state.data = action.payload;
                state.pending = false;
                state.error = undefined;
                state.initialState = false;
            })
            .addMatcher(isAnyOf(fetchMaterialsByType.rejected, fetchStillingBasingMaterials.rejected), (state, action) => {
                state.data = undefined;
                state.pending = false;
                state.error = {
                    status: (action.payload as any).status,
                    data: (action.payload as any).data,
                };
                state.initialState = false;
            });
    },
});

export const fetchMaterialsByType = createAsyncThunk('api/Material/GetMaterialsByType', async (type: MaterialType, { rejectWithValue }) => {
    try {
        const response = await BeMaccaferriStoreHelper.getMaterialsByTypeAsync(type);
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response);
    }
});

export const fetchStillingBasingMaterials = createAsyncThunk('api/Material/GetIsAvailableStillingBasinMaterials', async (_undefined, { rejectWithValue }) => {
    try {
        const response = await BeMaccaferriStoreHelper.getIsAvailableStillingBasinMaterials();
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response);
    }
});

export const selectMaterial = (state: RootState) => state.material;

export default materialSlice.reducer;
